// Route constants for the application
// These are used to ensure consistency across the app

export const ROUTES = {
  HOME: '/',
  LISTINGS: '/listings',
  MAP: '/map',
  CONTACT: '/contact',
  ESTATE_DETAIL: '/estate/:id',
  REGIONS: '/regions',
  REGION_DETAIL: '/region/:id',
  ABOUT: '/about',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  POPULAR_ESTATES: '/popular-estates',
  GOLF_ESTATES: '/golf-estates',
  BEACHFRONT_HOMES: '/beachfront-homes',
  LUXURY_ESTATES: '/luxury-estates',
  AUTH_CALLBACK: '/auth/callback',
};

// Helper function to get a route with parameters
export const getRoute = (route, params = {}) => {
  let result = route;
  
  // Replace route parameters with actual values
  Object.keys(params).forEach(key => {
    result = result.replace(`:${key}`, params[key]);
  });
  
  return result;
};

// Example usage:
// import { ROUTES, getRoute } from './routeConstants';
// 
// // For a simple route
// navigate(ROUTES.DASHBOARD);
// 
// // For a route with parameters
// navigate(getRoute(ROUTES.ESTATE_DETAIL, { id: estateId })); 